import { useState } from 'react';
import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif mb-3">
            常见<strong>问题</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            关于直播互动体验平台的常见疑问，这里都有答案
          </p>
        </div>
        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}